import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DivisionInterface } from 'src/app/interfaces/division.interface';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { runtimeEnvironment } from 'src/environments/runtimeEnvironment';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root'
})
export class DivisionService {

  private divisionUrl: string;
  private token: string;

  constructor(public _http: HttpClient, private _session: SessionService) {
    this.divisionUrl = runtimeEnvironment.test ? `${runtimeEnvironment.test}/datamaster/businessModels` : `${environment.apiUrl}/datamaster/businessModels`;
    this._session.getTokenSubj$().subscribe((usertoken: string) => {
      if (usertoken) {
        this.token = usertoken;
      }
    });
  }

  public getAllDivisions(idBusinessLine: number, filterText: string): Observable<DivisionInterface[]> {
    const reqHeader = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    let filter: string;
    let observable: Observable<DivisionInterface[]>;
    if (filterText != undefined && filterText != '' && filterText != null && filterText.length > 2) {
      filter = filterText.toString().trim().toLowerCase();
      observable = this._http.get<DivisionInterface[]>(`${this.divisionUrl}/${idBusinessLine}/divisions?name=${filter}`, { headers: reqHeader });
    } else {
      observable = this._http.get<DivisionInterface[]>(`${this.divisionUrl}/${idBusinessLine}/divisions`, { headers: reqHeader });
    }
    return observable;
  }

}

